import * as tslib_1 from "tslib";
import { StatusApprovalsPipe } from '@fuse/pipes/approvals-status/status-translate.pipe';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { chain, clone, isEqual, sortBy } from 'lodash';
import * as moment from 'moment-timezone';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../@fuse/services/translation-loader.service";
import * as i2 from "@ngx-translate/core";
import * as i3 from "../../../../../../../@fuse/pipes/approvals-status/status-translate.pipe";
var CreateEquipmentApprovalsLogsService = /** @class */ (function () {
    function CreateEquipmentApprovalsLogsService(fuseTranslationLoaderService, translateService, statusApprovalsPipe) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.translateService = translateService;
        this.statusApprovalsPipe = statusApprovalsPipe;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    CreateEquipmentApprovalsLogsService.prototype.listApprovalsLogsMapped = function (equipmentLogs, approvals) {
        var e_1, _a;
        var equipmentsLogsSorted = sortBy(equipmentLogs, function (equipmentLog) { return moment(equipmentLog.createdAt); });
        var approvalsLogsSortedByCreatedAt = sortBy(approvals, function (approvalLog) { return moment(approvalLog.createdAt); });
        var equipmentApprovalsLogsMapped = [];
        var _loop_1 = function (approval) {
            var previousLog = equipmentsLogsSorted
                .filter(function (equipmentLog) { return moment(equipmentLog.createdAt).isBefore(moment(approval.createdAt)); })
                .pop();
            var approvalLog = {
                approval: approval,
                updatedBy: approval.resolvedBy,
                approvedStatus: 'pending',
                clientApplicationName: approval.clientApplicationName,
                icon: 'ic_scheduled_20px',
                eventName: this_1.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.APPROVALS.CREATED_TITLE', {
                    status: this_1.statusApprovalsPipe.transform('pending').toLowerCase()
                }),
                colorClass: 'pending',
                formattedCreatedAt: moment(approval.createdAt).local().format('DD/MM/YYYY'),
                createdAt: moment(approval.createdAt),
                showDiffApproval: false,
                eventDescription: this_1.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.APPROVALS.CREATED_DESCRIPTION', {
                    number: approval.equipment.number,
                    name: approval.equipment.name
                })
            };
            if (!previousLog) {
                equipmentApprovalsLogsMapped.push(tslib_1.__assign({}, approvalLog, { showMessage: false }));
            }
            var approvedCreateEquipmentLog = this_1.generateApprovedApproval({ approvalLog: approvalLog, previousLog: previousLog });
            if (approvedCreateEquipmentLog) {
                equipmentApprovalsLogsMapped.push(approvedCreateEquipmentLog);
            }
            var refusedCreateEquipmentLog = this_1.generateRefusedApproval({ approvalLog: approvalLog, previousLog: previousLog });
            if (refusedCreateEquipmentLog) {
                equipmentApprovalsLogsMapped.push(refusedCreateEquipmentLog);
            }
            var updatedEquipmentLog = this_1.generateUpdateApproval({ approvalLog: approvalLog, previousLog: previousLog });
            if (updatedEquipmentLog) {
                equipmentApprovalsLogsMapped.push(updatedEquipmentLog);
            }
        };
        var this_1 = this;
        try {
            for (var approvalsLogsSortedByCreatedAt_1 = tslib_1.__values(approvalsLogsSortedByCreatedAt), approvalsLogsSortedByCreatedAt_1_1 = approvalsLogsSortedByCreatedAt_1.next(); !approvalsLogsSortedByCreatedAt_1_1.done; approvalsLogsSortedByCreatedAt_1_1 = approvalsLogsSortedByCreatedAt_1.next()) {
                var approval = approvalsLogsSortedByCreatedAt_1_1.value;
                _loop_1(approval);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (approvalsLogsSortedByCreatedAt_1_1 && !approvalsLogsSortedByCreatedAt_1_1.done && (_a = approvalsLogsSortedByCreatedAt_1.return)) _a.call(approvalsLogsSortedByCreatedAt_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return equipmentApprovalsLogsMapped;
    };
    CreateEquipmentApprovalsLogsService.prototype.generateApprovedApproval = function (_a) {
        var approvalLog = _a.approvalLog, previousLog = _a.previousLog;
        if (approvalLog.approval.status !== 'approved') {
            return null;
        }
        var approvedApprovalLog = clone(approvalLog);
        approvedApprovalLog.icon = 'ic_done_20px';
        approvedApprovalLog.colorClass = 'done';
        approvedApprovalLog.approvedStatus = approvalLog.approval.status;
        approvedApprovalLog.eventName = !previousLog
            ? this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.APPROVALS.CREATED_TITLE', {
                status: this.statusApprovalsPipe.transform(approvalLog.approval.status).toLowerCase()
            })
            : this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.APPROVALS.APPROVAL_TITLE', {
                status: this.statusApprovalsPipe.transform(approvalLog.approval.status).toLowerCase()
            });
        approvedApprovalLog.eventDescription = approvalLog.approval.notes
            ? this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NOTES.DESCRIPTION', {
                notes: approvalLog.approval.notes
            })
            : this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NOTES.WITHOUT_NOTES');
        approvedApprovalLog.createdAt = moment(approvalLog.approval.resolvedAt);
        approvedApprovalLog.formattedCreatedAt = moment(approvalLog.approval.resolvedAt).local().format('DD/MM/YYYY');
        approvedApprovalLog.updatedBy = approvalLog.approval.resolvedBy;
        return approvedApprovalLog;
    };
    CreateEquipmentApprovalsLogsService.prototype.generateRefusedApproval = function (_a) {
        var approvalLog = _a.approvalLog, previousLog = _a.previousLog;
        if (approvalLog.approval.status !== 'refused') {
            return null;
        }
        var refusedApprovalLog = clone(approvalLog);
        refusedApprovalLog.icon = 'ic_reported_20px';
        refusedApprovalLog.colorClass = 'refused';
        refusedApprovalLog.approvedStatus = approvalLog.approval.status;
        refusedApprovalLog.eventName = !previousLog
            ? this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.APPROVALS.CREATED_TITLE', {
                status: this.statusApprovalsPipe.transform(approvalLog.approval.status).toLowerCase()
            })
            : this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.APPROVALS.APPROVAL_TITLE', {
                status: this.statusApprovalsPipe.transform(approvalLog.approval.status).toLowerCase()
            });
        refusedApprovalLog.eventDescription = approvalLog.approval.notes
            ? this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NOTES.DESCRIPTION', {
                notes: approvalLog.approval.notes
            })
            : this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NOTES.WITHOUT_NOTES');
        refusedApprovalLog.createdAt = moment(approvalLog.approval.resolvedAt);
        refusedApprovalLog.formattedCreatedAt = moment(approvalLog.approval.resolvedAt).local().format('DD/MM/YYYY');
        refusedApprovalLog.updatedBy = approvalLog.approval.resolvedBy;
        return refusedApprovalLog;
    };
    CreateEquipmentApprovalsLogsService.prototype.generateUpdateApproval = function (_a) {
        var approvalLog = _a.approvalLog, previousLog = _a.previousLog;
        if (!previousLog) {
            return null;
        }
        var updatedApprovalLog = clone(approvalLog);
        updatedApprovalLog.attachments = this.approvalAttachments({ approvalLog: approvalLog, previousLog: previousLog });
        updatedApprovalLog.customFields = this.approvalCustomFields({ approvalLog: approvalLog, previousLog: previousLog });
        updatedApprovalLog.approval.notesDescription = this.approvalNotes({ approvalLog: approvalLog, previousLog: previousLog });
        updatedApprovalLog.approval.nameDescription = this.approvalName({ approvalLog: approvalLog, previousLog: previousLog });
        updatedApprovalLog.approval.typeDescription = this.approvalEquipmentType({ approvalLog: approvalLog, previousLog: previousLog });
        updatedApprovalLog.approval.numberDescription = this.approvalNumber({ approvalLog: approvalLog, previousLog: previousLog });
        updatedApprovalLog.approval.locationDescription = this.approvalLocation({ approvalLog: approvalLog, previousLog: previousLog });
        updatedApprovalLog.eventDescription = null;
        updatedApprovalLog.showDiffApproval = true;
        updatedApprovalLog.eventName = this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.APPROVALS.APPROVAL_TITLE', {
            status: this.statusApprovalsPipe.transform('pending').toLowerCase()
        });
        return updatedApprovalLog;
    };
    CreateEquipmentApprovalsLogsService.prototype.approvalAttachments = function (_a) {
        var approvalLog = _a.approvalLog, previousLog = _a.previousLog;
        if (!(approvalLog.approval.equipment.attachments && approvalLog.approval.equipment.attachments.length)) {
            return null;
        }
        var approvalAttachments = sortBy(approvalLog.approval.equipment.attachments, function (attachment) {
            return moment(attachment.createdAt);
        });
        var equipmentAttachments = sortBy(previousLog.snapshot.attachments, function (attachment) { return moment(attachment.createdAt); });
        if (isEqual(approvalAttachments, equipmentAttachments)) {
            return null;
        }
        var attachmentsAdded = [];
        var attachmentsRemoved = [];
        approvalAttachments.forEach(function (_a) {
            var id = _a.id, path = _a.path;
            var existingAttachment = equipmentAttachments.find(function (equipmentAttachment) {
                return equipmentAttachment.id === id;
            });
            if (!existingAttachment) {
                attachmentsAdded.push({
                    id: id,
                    path: path
                });
            }
        });
        equipmentAttachments.forEach(function (_a) {
            var id = _a.id, path = _a.path;
            var existingAttachment = approvalAttachments.find(function (approvalAttachment) {
                return approvalAttachment.id === id;
            });
            if (!existingAttachment) {
                attachmentsRemoved.push({
                    id: id,
                    path: path
                });
            }
        });
        var attachments = {
            added: {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.ATTACHMENTS.ADDED'),
                items: attachmentsAdded
            },
            removed: {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.ATTACHMENTS.REMOVED'),
                items: attachmentsRemoved
            }
        };
        return attachments;
    };
    CreateEquipmentApprovalsLogsService.prototype.approvalCustomFields = function (_a) {
        var _this = this;
        var approvalLog = _a.approvalLog, previousLog = _a.previousLog;
        if (!(approvalLog.approval && approvalLog.approval.equipment && approvalLog.approval.equipment.customFields && approvalLog.approval.equipment.customFields.length)) {
            return null;
        }
        var approvalCustomFields = chain(approvalLog.approval.equipment.customFields)
            .map(function (_a) {
            var name = _a.name, value = _a.value, type = _a.type;
            return ({ name: name, value: value, type: type });
        })
            .sortBy('name')
            .value();
        var equipmentCustomFields = chain(previousLog.snapshot.customFields)
            .map(function (_a) {
            var name = _a.name, value = _a.value, type = _a.type;
            return ({ name: name, value: value, type: type });
        })
            .sortBy('name')
            .value();
        if (isEqual(approvalCustomFields, equipmentCustomFields)) {
            return null;
        }
        var customsFieldsAdded = [];
        var customsFieldsUpdated = [];
        var customsFieldsRemoved = [];
        approvalCustomFields.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            var existingCustomField = equipmentCustomFields.find(function (previousCustomField) {
                return previousCustomField.name === name;
            });
            if (existingCustomField) {
                if (existingCustomField.value !== value) {
                    customsFieldsUpdated.push({
                        name: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.QUESTION', {
                            question: name
                        }),
                        value: _this.normalizeCustomFieldValue(value)
                    });
                }
            }
            else {
                customsFieldsAdded.push({
                    name: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.QUESTION', {
                        question: name
                    }),
                    value: _this.normalizeCustomFieldValue(value)
                });
            }
        });
        equipmentCustomFields.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            var existingCustomField = approvalCustomFields.find(function (currentCustomField) {
                return currentCustomField.name === name;
            });
            if (!existingCustomField) {
                customsFieldsRemoved.push({
                    name: _this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.QUESTION', {
                        question: name
                    }),
                    value: _this.normalizeCustomFieldValue(value)
                });
            }
        });
        var customFields = {
            added: {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.ANSWER_ADDED'),
                items: customsFieldsAdded
            },
            updated: {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.ANSWER_UPDATED'),
                items: customsFieldsUpdated
            },
            removed: {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.ANSWER_REMOVED'),
                items: customsFieldsRemoved
            }
        };
        return customFields;
    };
    CreateEquipmentApprovalsLogsService.prototype.approvalNotes = function (_a) {
        var approvalLog = _a.approvalLog, previousLog = _a.previousLog;
        if (approvalLog.approval.equipment.notes === previousLog.snapshot.notes) {
            return null;
        }
        if (approvalLog.approval.equipment.notes && !previousLog.snapshot.notes) {
            return {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NOTES.CREATED'),
                notes: approvalLog.approval.equipment.notes
            };
        }
        if (!approvalLog.approval.equipment.notes && previousLog.snapshot.notes) {
            return {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NOTES.REMOVED'),
                notes: previousLog.snapshot.notes
            };
        }
        if (approvalLog.approval.equipment.notes !== previousLog.snapshot.notes) {
            return {
                title: this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NOTES.UPDATED'),
                notes: approvalLog.approval.equipment.notes
            };
        }
    };
    CreateEquipmentApprovalsLogsService.prototype.approvalName = function (_a) {
        var approvalLog = _a.approvalLog, previousLog = _a.previousLog;
        if (approvalLog.approval.equipment.name === previousLog.snapshot.name) {
            return null;
        }
        return this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NAME.DESCRIPTION', {
            currentName: approvalLog.approval.equipment.name,
            previousName: previousLog.snapshot.name
        });
    };
    CreateEquipmentApprovalsLogsService.prototype.approvalNumber = function (_a) {
        var approvalLog = _a.approvalLog, previousLog = _a.previousLog;
        if (approvalLog.approval.equipment.number === previousLog.snapshot.number) {
            return null;
        }
        return this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.NUMBER.DESCRIPTION', {
            currentNumber: approvalLog.approval.equipment.number,
            previousNumber: previousLog.snapshot.number
        });
    };
    CreateEquipmentApprovalsLogsService.prototype.approvalEquipmentType = function (_a) {
        var approvalLog = _a.approvalLog, previousLog = _a.previousLog;
        var approvalTypeId = approvalLog.approval.equipment.type && approvalLog.approval.equipment.type.id;
        var equipmentTypeId = previousLog.snapshot.type && previousLog.snapshot.type.id;
        if (approvalTypeId === equipmentTypeId) {
            return null;
        }
        return this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.TYPE.DESCRIPTION', {
            previousType: previousLog.snapshot.type.name,
            currentType: approvalLog.approval.equipment.type.name
        });
    };
    CreateEquipmentApprovalsLogsService.prototype.approvalLocation = function (_a) {
        var approvalLog = _a.approvalLog, previousLog = _a.previousLog;
        var approvalLocationId = approvalLog.approval.equipment.location && approvalLog.approval.equipment.location.id;
        var equipmentLocationId = previousLog.snapshot.location && previousLog.snapshot.location.id;
        if (approvalLocationId === equipmentLocationId) {
            return null;
        }
        if (approvalLog.approval.equipment.location === previousLog.snapshot.location) {
            return null;
        }
        return this.translateService.instant('EQUIPMENTS.DIALOG.HISTORIC.EVENTS.LOCATION.DESCRIPTION', {
            currentLocation: approvalLog.approval.equipment.location.name,
            previousLocation: previousLog.snapshot.location.name
        });
    };
    CreateEquipmentApprovalsLogsService.prototype.normalizeCustomFieldValue = function (value) {
        var datePattern = /^\d{4}-\d{2}-\d{2}/;
        return datePattern.test(value) ? moment(value).local().format('DD/MM/YYYY') : value;
    };
    CreateEquipmentApprovalsLogsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CreateEquipmentApprovalsLogsService_Factory() { return new CreateEquipmentApprovalsLogsService(i0.ɵɵinject(i1.FuseTranslationLoaderService), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.StatusApprovalsPipe)); }, token: CreateEquipmentApprovalsLogsService, providedIn: "root" });
    return CreateEquipmentApprovalsLogsService;
}());
export { CreateEquipmentApprovalsLogsService };
